<template>
  <div class="body">
    <van-nav-bar
      title
      left-text
      right-text="保存"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
      class="topNav userinfo"
    />
    <div class="content">
      <p class="content_head">我的个人信息</p>
      <div class="infoWrap">
        <label class="name">头像</label>
        <div class="img">
          <van-uploader :after-read="afterRead">
            <img :src="img | thumbnail(180,180)">
          </van-uploader>
        </div>
      </div>
      <div class="infoWrap">
        <label class="name">我的昵称</label>
        <input type="text" v-model="name">
      </div>
      <div class="infoWrap">
        <label class="name">手机号</label>
        <input type="text" v-model="phone" disabled="disabled" style="color:#999">
      </div>
      <div class="infoWrap">
        <label class="name">性别</label>
        <van-radio-group v-model="sex" class="radioGroup">
          <van-radio name="1" class="radio" checked-color="#e9aea8">男</van-radio>
          <van-radio name="2" class="radio" checked-color="#e9aea8">女</van-radio>
        </van-radio-group>
      </div>
    </div>
    <div id="clipArea"></div>
  </div>
</template>

<script>
import { userinfo, update_userinfo, SetUserInfo } from "../../apis/https.js";
import { getLocalStorage } from "../../utils/storage.js";
import { RadioGroup, Radio, Uploader } from "vant";
import Vue from "vue";
import * as qiNiu from "qiniu-js";
import HtmlImageCompress from "@/utils/HtmlImageCompress";
Vue.use(RadioGroup)
  .use(Radio)
  .use(Uploader);
export default {
  components: {},
  data() {
    return {
      img: "",
      phone: "",
      name: "",
      sex: "",
      pc: null
    };
  },
  created() {},
  activated() {
    userinfo(getLocalStorage("login_token")).then(res => {
      this.img =
        res.data.avatarUrl || require("../../assets/frame-img/user.png");
      this.name = res.data.nickName;
      this.sex = res.data.gender == "男" ? "1" : "2";
      this.phone = res.data.mobile;
    });
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      //nickName,avatarUrl,gender,token
      let promise1 = SetUserInfo(
        this.name,
        this.img,
        this.sex,
        getLocalStorage("login_token")
      );
      let promise2 = update_userinfo({
        name: this.name,
        // sex: this.sex,
        avatar: this.img
      });
      let that = this;
      Promise.all([promise1, promise2]).then(function() {
        that.$router.replace("/pages/user/index");
      });
      // {name, sex, avatar, birthday, introduction}
    },
    afterRead(file) {
      let htmlImageCompress = new HtmlImageCompress(file.content, {
        width: 360,
        height: 360,
        quality: 1
      });
      htmlImageCompress
        .then(result => {
          // this.onQueue();
          this.$store.dispatch("RefreshQiNiu").then(config => {
            let subscription = qiNiu
              .upload(result.blob, config.key, config.token, {
                useCdnDomain: true,
                region: qiNiu.region.z2
              })
              .subscribe(
                total => {},
                error => {
                  Toast("上传错误,请重试");
                  console.log(error);
                },
                response => {
                  // Toast('上传成功');
                  // console.log(response);
                  // console.log(task);
                  this.img = `${config.domain}/${config.key}`;
                }
              );
            // subscription.unsubscribe() // 上传取消
          });
        })
        .catch(err => {
          // 处理失败会执行
          this.queueUpload.splice(task.index - 1, 1);
          Toast("处理图像异常了,请重试~");
          console.log(err);
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../style/skin.less");
.body {
  background: @white;
  min-height: 100vh;
  overflow: hidden;
  .topNav {
    position: fixed;
    width: 100%;
    top: 0px;
    i {
      color: #323233 !important;
    }
  }
  .content {
    margin-top: 46px;
    padding: 0px 20px;
    .content_head {
      font-size: 16px;
      color: @lightP;
      height: 120px;
      padding-top: 20px;
    }
    .infoWrap {
      border-bottom: 1px solid @lightLine;
      margin-bottom: 10px;
      overflow: hidden;
      height: 70px;
      padding: 5px 0px;
      .name {
        float: left;
        display: block;
        font-size: 14px;
        height: 60px;
        line-height: 60px;
      }
      .img {
        float: right;
        height: 60px;
        width: 60px;
        border-radius: 30px;
        overflow: hidden;
        margin-right: 20px;
        img {
          height: 100%;
          width: 100%;
        }
      }
      input {
        float: right;
        width: 200px;
        font-size: 14px;
        border: 0px;
        height: 60px;
        background: transparent;
        padding: 0px;
        line-height: 60px;
        text-align: right;
      }
      .radioGroup {
        float: right;
        overflow: hidden;
        .radio {
          line-height: 60px;
          font-size: 14px;
          float: left;
          margin-left: 10px;
        }
      }
    }
  }
}
.userinfo .van-nav-bar__text {
  color: @text;
}
</style>
